import { Component, ElementRef, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-balloons-overlay',
  template: '',
  styleUrls: ['./balloons-overlay.component.scss']
})
export class BalloonsOverlayComponent implements OnInit, OnDestroy {
  private balloonEls: HTMLElement[] = [];
  private destroyed = false;

  constructor(
    private host: ElementRef<HTMLElement>,
    private r: Renderer2,
    private zone: NgZone
  ) {}

ngOnInit(): void {
  this.zone.runOutsideAngular(() => {
    setTimeout(() => {
      if (!this.destroyed) {
        this.spawn();
      }
    }, 1000); // ⏱️ 1 segundo de espera
  });
}

  ngOnDestroy(): void {
    this.destroyed = true;
    this.balloonEls.forEach(el => { try { el.remove(); } catch {} });
    this.balloonEls = [];
  }

  /**
   * @param forcedCount si lo pasas, fuerza nº de globos (útil para la 2ª oleada)
   * @param isSecondWave si es 2ª oleada, ajustamos delays un poco
   */
  private spawn(forcedCount?: number, isSecondWave = false): void {
    const root = this.host.nativeElement;
    this.r.addClass(root, 'balloons-overlay');

    const src = 'assets/images/100Aniversary/globo.png';

    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    // ✅ BONUS: count adaptativo (mín 12, máx 18)
    const adaptiveCount = Math.min(18, Math.max(12, Math.round(vw / 120)));
    const count = forcedCount ?? adaptiveCount;

    // ✅ “salirse” un poco del viewport
    const overshoot = 0.10 * vw;         // 10% a cada lado
    const usableW = vw + overshoot * 2;  // ancho expandido

    // ✅ random estratificado (slots)
    const slotW = usableW / count;
    const jitter = slotW * 0.55;         // cuánto puede moverse dentro del slot

    const rand = (a: number, b: number) => a + Math.random() * (b - a);
    const rint = (a: number, b: number) => Math.floor(rand(a, b + 1));

    for (let i = 0; i < count; i++) {
      const img = this.r.createElement('img') as HTMLImageElement;
      img.src = src;
      img.alt = '';
      this.r.addClass(img, 'balloon');

      // Duración y drift
      const durationMs = rint(2800, 5000);
      const xDriftPx = rint(-90, 90);
      const z = 999990 + rint(0, 300) + i;

      // ✅ Delay (si es 2ª oleada, empezamos un poco después para que no se pisen)
      const delayMs = isSecondWave ? rint(500, 1400) : rint(0, 900);

      // ✅ Posición: centro de slot + jitter
      const slotCenter = (i + 0.5) * slotW;
      const dx = (Math.random() - 0.5) * jitter;
      const leftPx = Math.round(slotCenter + dx - overshoot);

      // ✅ BONUS: tamaño variable (sin tocar transform, así no rompe la animación)
      // Base: 13vw, con variación suave
      const widthVw = 13 * (0.85 + Math.random() * 0.35); // ~11vw..15.6vw

      this.r.setStyle(img, 'left', `${leftPx}px`);
      this.r.setStyle(img, 'width', `${widthVw}vw`);
      this.r.setStyle(img, 'animation-duration', `${durationMs}ms`);
      this.r.setStyle(img, 'animation-delay', `${delayMs}ms`);
      this.r.setStyle(img, 'z-index', `${z}`);
      this.r.setStyle(img, '--xdrift', `${xDriftPx}px`);

      img.addEventListener('animationend', () => {
        if (this.destroyed) return;
        try { img.remove(); } catch {}
      }, { once: true });

      this.r.appendChild(root, img);
      this.balloonEls.push(img);
    }
  }
}
